import { SELECTED_UNIT_ENUM_OBJECT_MAP } from '../../../settings/settings';

const BENEFICIARY_TYPE = {
  primary: {
    enumerationID: 0,
    enumerationName: 'p',
  },
  secondary: {
    enumerationID: 1,
    enumerationName: 's',
  },
};

const BENEFICIARY_RELATIONSHIP = {
  parent: {
    enumerationID: 100,
    enumerationName: 'p',
    displayName: 'Parent',
  },
  spouse: {
    enumerationID: 101,
    enumerationName: 's',
    displayName: 'Spouse',
  },
  child: {
    enumerationID: 102,
    enumerationName: 'c',
    displayName: 'Child',
  },
  sibling: {
    enumerationID: 103,
    enumerationName: 'b',
    displayName: 'Sibling',
  },
  other: {
    enumerationID: 104,
    enumerationName: 'o',
    displayName: 'Other',
  },
  entity: {
    enumerationID: 105,
    enumerationName: 'e',
    displayName: 'Entity',
  },
};

const BENEFICIARY_ENTITYTYPE = {
  individual: {
    individualOrOrganizationCode: 'I',
    enumerationID: 1,
    enumerationName: 'Customer',
  },
  entity: {
    individualOrOrganizationCode: 'O',
    enumerationID: 2,
    enumerationName: 'Business Entity',
  },
};

// Step 1 will always be using existing accounts
const FUND_SUBTYPE = {
  existing: {
    enumerationID: 1033,
    enumerationName: 'ExistingAccount',
  },
  new: {
    enumerationID: 1032,
    enumerationName: 'NewAccount',
  },
};

export const BENEFICIARY_MAP = {
  type: BENEFICIARY_TYPE,
  relationship: BENEFICIARY_RELATIONSHIP,
  entityType: BENEFICIARY_ENTITYTYPE,
};

export const FUND_MAP = {
  unit: SELECTED_UNIT_ENUM_OBJECT_MAP,
  subType: FUND_SUBTYPE,
};
